import FlashMessage from './FlashMessage'

export default FlashMessage
